import { put } from 'core/middlewares/utilities';
import { search, catalog, utilities } from 'core/use-cases';

type PersistedExpiration = utilities.ActionFailure | utilities.ActionSuccess;

/**
 * Broker responsible for expiration to your persisted store
 *
 */
export function* persistedExpiration(action: PersistedExpiration) {
  const isCatalog = [
    catalog.actions.catalogFetch.failure.type,
    catalog.actions.catalogFetch.success.type,
  ].some((item) => item === action.type);

  if (isCatalog) {
    yield put(search.actions.searchCleanUp());
  }
}
